<template>
  <div class="container-fluid">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body row justify-content-center">
          <div class="col-lg-1 text-center">
            <!-- fecha {{ today }} -->
            <!-- <button class="ml-5 btnAddOrder btnAddRow" @click="addRows(10)">+</button> -->
            <b-button variant="success" class="btn" @click="addRows(2)">
              <font-awesome-icon :icon="['fa', 'plus']" class="fontIconBtn" size="3x"/>
              <!-- <span class="fontButt"><b> Guardar</b></span> -->
            </b-button>
          </div>
          <div class="col-lg-2 text-center">
            <!-- <button class="ml-5 btnAddOrder btnRegister" @click="register">Registrar Pedido</button> -->
            <b-button variant="primary" type="submit" class="btn" @click="register">
              <font-awesome-icon :icon="['fa', 'pencil-alt']" class="fontIconBtn"/><br/>
              <span class="fontButt"><b>Registrar Pedido</b></span>
            </b-button>
          </div>
          <div class="col-lg-1 text-center">
            <!-- <button class="ml-5 btnAddOrder btnRegister" @click="savePedidos">Guardar</button> -->
            <b-button variant="secondary" type="submit" class="btn" @click="savePedidos">
              <font-awesome-icon :icon="['fa', 'save']" class="fontIconBtn"/><br/>
              <span class="fontButt"><b> Guardar</b></span>
            </b-button>
          </div>
          <div class="col-lg-1 text-center">
            <!-- <button class="ml-5 btnAddOrder btnDelete" @click="eliminarPedidos">Eliminar</button> -->
            <b-button variant="warning" type="submit" class="btn" @click="$modal.show('duplicate')">
              <font-awesome-icon :icon="['fa', 'copy']" class="fontIconBtn"/><br/>
              <span class="fontButt"><b>Duplicar</b></span>
            </b-button>
          </div>
          <div class="col-lg-1 text-center">
            <!-- <button class="ml-5 btnAddOrder btnDelete" @click="eliminarPedidos">Eliminar</button> -->
            <b-button variant="dark" type="submit" class="btn" @click="agregarFaltante">
              <font-awesome-icon :icon="['fa', 'book-dead']" class="fontIconBtn"/><br/>
              <span class="fontButt"><b>Faltante</b></span>
            </b-button>
          </div>
          <div class="col-lg-1 text-center">
            <!-- <button class="ml-5 btnAddOrder btnDelete" @click="eliminarPedidos">Eliminar</button> -->
            <b-button variant="danger" type="submit" class="btn" @click="eliminarPedidos">
              <font-awesome-icon :icon="['fa', 'trash']" class="fontIconBtn"/><br/>
              <span class="fontButt"><b>Eliminar</b></span>
            </b-button>
          </div>
        </div>
      </div>
      <!-- {{user}} -->
      <!-- <div class="card" v-if="client.id_client > 0"> -->
      <div class="card">
        <div class="card-body">
          <vue-excel-editor ref="grid" v-model="jsondata" :cell-style='mystyleAdd' :key="jsondata.length" no-paging filter-row autocomplete>
            <vue-excel-column field="user" label="Usuario" textTransform="uppercase" readonly/>
            <vue-excel-column field="client" type='select' label="# Cliente" width="60px" textTransform="uppercase" :change="updateClientValue" :options="optionsClient" />
            <vue-excel-column field="nameClient" type='select' label="Cliente" width="200px" textTransform="uppercase" :change="updateClientValue" :options="optionsClient"/>
            <vue-excel-column field="empresa" type='select' label="Proveedor" width="180px" textTransform="uppercase" :change="updateEnterpriseValue" :options="optionsEnterprise"/>
            <vue-excel-column field="catalogo"  label="Catalogo" width="120px" :options="optionsCatalogo" :change="addList" textTransform="uppercase"/>
            <vue-excel-column field="cantidad"  label="Cantidad" width="70px" type="number"/>
            <vue-excel-column field="pagina" label="Pagina" width="60px" textTransform="uppercase" type="number"/>
            <vue-excel-column field="comentario" label="Comentario" width="100px" textTransform="uppercase"/>
            <vue-excel-column field="marca"  label="Marca" width="180px" :options="optionsMarca" textTransform="uppercase"/>
            <!-- <vue-excel-column field="modelo"  label="Modelo" width="180px" textTransform="uppercase" :change="updateModel"/> -->
            <vue-excel-column field="modelo"  label="Modelo" width="180px" textTransform="uppercase"/>
            <vue-excel-column field="color"  label="Color" width="180px" textTransform="uppercase"/>
            <!-- <vue-excel-column field="numero"  label="Talla" width="180px" textTransform="uppercase" :change="updateNumber"/> -->
            <vue-excel-column field="numero"  label="Talla" width="180px" textTransform="uppercase"/>
            <vue-excel-column field="delivery_date"  label="Fecha" width="120px" textTransform="uppercase"/>
            <vue-excel-column field="campo_muerto"  label="Texto abierto" width="120px" textTransform="uppercase"/>
        </vue-excel-editor>
        </div>
      </div>
    </div>
    <modal name="duplicate" :adaptive="true" :scrollable="true" height="250" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('duplicate')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Duplicar registro</h2>
        <div class="row justify-content-center">
          <input type="number" class="col-8 form-control" min="1" v-model="duplicateE" placeholder="Cantidad de elementos" name="" id="">
        </div>
        <div class="row justify-content-center mt-3">
          <button class="btn btn-success" @click="duplicar">Duplicar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import * as moment from 'moment'
import { mapGetters } from 'vuex'
import { BButton } from 'bootstrap-vue'

import 'moment-timezone'
moment().tz('America/Mexico_City').format()
export default {
  mixins: [formatData],
  components: {
    BButton
  },
  data () {
    return {
      duplicateE: 1,
      tabIndex: 0,
      client: {
        id_cliente: 0,
        fullname: '',
        phone: ''
      },
      clientNumber: '',
      optionsCatalogo: [],
      enterprises: [],
      clients: [],
      optionsMarca: [],
      optionsEnterprise: [],
      optionsClient: [],
      jsondata: []
    }
  },
  methods: {
    mystyleAdd (col, pre) {
      if (pre.name === 'catalogo') {
        return {
          background: ''
        }
      } else {
        return ''
      }
    },
    async searchClient (key) {
      try {
        if (key > 0) {
          const request = {
            key: key,
            id_empresa: this.user.enterprise_id
          }
          const params = await this.toFormData(request)
          const response = await axiosAdelaService.post('/searchClients', params)
          if (response.status === 200) {
            if (response.data.totalRecords > 0) {
              this.client = response.data.rows[0]
            } else {
              this.client = []
            }
          }
        } else {
          this.client = []
        }
      } catch (error) {
        console.info(error)
      }
    },
    async register () {
      try {
        const completeRegisters = []
        const selected = this.$refs.grid.selectedCount
        if (selected > 0) {
          const seleccionados = this.$refs.grid.getSelectedRecords()
          // buscar si los seleccionados tiene order
          seleccionados.forEach(async el => {
            console.log(el)
            if (el.order !== undefined) {
              const c = el.client.toString().split('-')
              el.client = c[0]
              completeRegisters.push(el)
            }
          })
        } else {
          this.jsondata.forEach(element => {
            if (element.catalogo !== '') {
              console.log(element.client.toString().split('-'))
              const c = element.client.toString().split('-')
              element.client = c[0]
              completeRegisters.push(element)
            }
          })
        }
        const request = {
          // data: JSON.stringify(completeRegisters),
          data: completeRegisters,
          idClient: this.client.id_client,
          userId: this.user.user_admin_id,
          enterpriseId: this.user.enterprise_id
        }
        console.log('this.jsondata', request)
        // const params = await this.toFormData(request)
        const response = await axiosAdelaService.post('savePedidos', request)
        console.log('register savePedidos', response)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se agrego el pedido correctamente.',
            type: 'success'
          })
          this.$router.push({ name: 'orders' })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo agregar la orden, intentalo mas tarde')
      }
    },
    async savePedidos () {
      try {
        const completeRegisters = []
        this.jsondata.forEach(element => {
          if (element.catalogo !== '' && element.client !== '') {
            completeRegisters.push(element)
            const c = element.client.toString().split('-')
            element.client = c[0]
          }
        })
        // console.log('Registros completos', completeRegisters)
        const request = {
          data: completeRegisters,
          idClient: this.client.id_client,
          userId: this.user.user_admin_id,
          enterpriseId: this.user.enterprise_id
        }
        console.log('saveOrders XXXD', request)
        const response = await axiosAdelaService.post('/saveOrders', request)
        console.log('saveOrders xxxdDD', response)
        if (response.status === 200) {
          await this.getOrdersSaved()
          this.$toastedPush({
            message: 'Se guardo el pedido correctamente.',
            type: 'success'
          })
          // this.$router.push({ name: 'orders' })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo agregar la orden, intentalo mas tarde')
      }
    },
    addRows (items) {
      for (let index = 0; index <= items; index++) {
        this.jsondata.push(
          { user: this.user.user_admin_id + '-' + this.user.name, client: '', nameClient: '', catalogo: '', cantidad: 1, pagina: '', comentario: '', marca: '', modelo: '', color: '', numero: '', precio: '', venta: '', delivery_date: '', date: '', campo_muerto: '' }
        )
      }
    },
    addList (...args) {
      if (args[3].name === 'catalogo') {
        if (!this.optionsCatalogo.includes(args[0])) {
          this.optionsCatalogo.push(args[0])
        }
      }
      if (args[3].name === 'marca') {
        if (!this.optionsMarca.includes(args[0])) {
          this.optionsMarca.push(args[0])
        }
      }
    },
    async eliminarPedidos () {
      const selected = this.$refs.grid.selectedCount
      const elementSave = []
      const elementDelete = []
      if (selected > 0) {
        const seleccionados = this.$refs.grid.getSelectedRecords()
        // buscar si los seleccionados tiene order
        seleccionados.forEach(async el => {
          console.log(el)
          if (el.order !== undefined) {
            await this.borrarElemento(el.order)
          } else {
            elementDelete.push(el)
          }
        })
        this.jsondata.forEach(el => {
          if (el.catalogo !== '' && el.client !== '') {
            elementDelete.forEach(el2 => {
              if (el2.$id !== el.$id) {
                elementSave.push(el)
              }
            })
          }
        })
        this.jsondata = elementSave
        this.addRows(5)
      }
    },
    async borrarElemento (order) {
      try {
        const request = {
          order_id: order
        }
        const response = await axiosAdelaService.post('/deleteOrder', request)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se elimino la orden correctamente.',
            type: 'success'
          })
          const open = await this.getOrdersSaved()
          if (!open) {
            this.addRows(5)
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo agregar la orden, intentalo mas tarde')
      }
    },
    dateCalcule (...args) {
      const today = moment().format('YYYY-MM-DD')
      // const startWeek = moment().startOf('week').format('YYYY-MM-DD')
      const endWeek = moment().endOf('week').format('YYYY-MM-DD')
      let days1 = [3, 4, 5] // miercoles, jueves, viernes
      let days2 = [6, 0, 1, 2] // sabado, domingo, lunes, martes
      const nextWeek = moment(today).add(1, 'week').startOf('week').format('YYYY-MM-DD')
      let deliveryDay = ''
      let date = ''
      if (args[0] === 'ANDREA' || args[0] === 'MODA CLUB' || args[0] === 'STOP' || args[0] === 'DEVENDI' || args[0] === 'AGIL') {
        if (days1.includes(moment(today).day())) { // si hoy es miercoles, jueves o viernes  => llega el miercoles
          deliveryDay = moment(nextWeek).add(3, 'days').format('llll')
          date = moment(nextWeek).add(3, 'days').format('YYYY-MM-DD')
        } else if (days2.includes(moment(today).day())) { // si hoy en lunes o martes, sabado o domingo
          deliveryDay = moment(nextWeek).add(5, 'days').format('llll')
          date = moment(nextWeek).add(5, 'days').format('YYYY-MM-DD')
        }
      } else {
        days1 = [0, 1, 2, 3]
        days2 = [4, 5, 6]
        if (days1.includes(moment(today).day())) { // si hoy es lunes, martes o miercoles => entrega el sabado
          deliveryDay = moment(endWeek).add(6, 'days').format('llll')
          date = moment(endWeek).add(6, 'days').format('YYYY-MM-DD')
        } else if (days2.includes(moment(today).day())) { // si hoy es jueves, viernes o sabado => entrega el Miercoles
          deliveryDay = moment(nextWeek).add(2, 'days').format('llll')
          date = moment(nextWeek).add(2, 'days').format('YYYY-MM-DD')
        }
      }
      args[2].delivery_date = deliveryDay
      args[2].date = date
    },
    async getProviders () {
      try {
        const completeRegisters = []
        this.jsondata.forEach(element => {
          if (element.catalogo !== '') {
            completeRegisters.push(element)
          }
        })
        const request = {
          data: JSON.stringify(completeRegisters),
          idClient: this.client.id_client
        }
        const response = await axiosAdelaService.post('getProviders', request)
        if (response.status === 200) {
          this.enterprises = response.data.rows
          response.data.rows.forEach(element => {
            this.optionsEnterprise.push(element.name)
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas, por favor intentelo mas tarde')
      }
    },
    async getClients () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          key_client: '',
          name: '',
          email: '',
          phone: '',
          perPage: ''
        }
        console.log('params', request)
        const response = await axiosAdelaService.post('getClients', request)
        console.log('getClients', response)
        if (response.status === 200) {
          this.clients = response.data.rows
          response.data.rows.forEach(element => {
            this.optionsClient.push(element.key_client + '-' + element.name + ' ' + element.lastname1 + ' ' + element.lastname2)
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los clientes, por favor intentelo mas tarde')
      }
    },
    async getOrdersSaved () {
      try {
        this.jsondata = []
        const request = {
          enterprise_id: this.user.enterprise_id,
          userId: this.user.user_admin_id
        }
        const response = await axiosAdelaService.post('/getOrdersSaved', request)
        console.log('getOrdersSaved', response)
        if (response.status === 200) {
          /* if (response.data.rows.length > 0) { */
          if (response.data.totalRecords > 0) {
            const items = response.data.rows
            items.forEach(el => {
              let order = ''
              if (el.id_order !== '') {
                order = el.id_order
              }
              this.jsondata.push({
                user: this.user.user_admin_id + '-' + this.user.name,
                client: el.id_client,
                nameClient: el.fullname,
                catalogo: el.catalogo,
                cantidad: el.cantidad,
                pagina: el.pagina,
                comentario: el.comentario,
                marca: el.marca,
                modelo: el.modelo,
                color: el.color,
                numero: el.numero,
                precio: el.precio,
                venta: 0,
                delivery_date: el.delivery_date,
                date: '',
                order: order,
                id_order: order,
                empresa: el.provider,
                id_provider: el.id_provider,
                campo_muerto: el.campo_muerto
              })
            })
            this.addRows(5)
            return true
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No existen ordenes guardadas')
        return false
      }
    },
    async calculateDates (provider) {
      try {
        console.log('PROVIDER *****', provider)
        const request = {
          month: parseInt(moment().format('MM')),
          year: parseInt(moment().format('YYYY')),
          provider_id: parseInt(provider.id_provider),
          enterprise_id: parseInt(this.user.enterprise_id)
        }
        const enterprise = await axiosAdelaService.post('/getRelationDates', request)
        console.log('getRelationDates', enterprise.data)
        if (enterprise.status === 200) {
          if (enterprise.data.rows.length > 0) {
            // const today = moment().format('YYYY-MM-DD')
            // console.log('hoy es ', today)
            let nameDate = 'SIN FECHA'
            const filas = enterprise.data.rows
            for (const key in filas) {
              const compareDate = moment()
              const startDate1 = moment(filas[key].date_init)
              const endDate1 = moment(filas[key].date_end)
              console.log('AQUI RESPONDE', compareDate.isBetween(startDate1, endDate1), compareDate.format('YYYY-MM-DD') === startDate1.format('YYYY-MM-DD'), compareDate.format('YYYY-MM-DD') === endDate1.format('YYYY-MM-DD'))
              if (compareDate.isBetween(startDate1, endDate1) || compareDate.format('YYYY-MM-DD') === startDate1.format('YYYY-MM-DD') || compareDate.format('YYYY-MM-DD') === endDate1.format('YYYY-MM-DD')) {
                nameDate = filas[key].name
              }
              // // console.log('enterprise.data[key]', filas[key])
              // var startDate = moment(filas[key].date_init).format('YYYY-MM-DD')
              // var endDate = moment(filas[key].date_end).format('YYYY-MM-DD')
              // console.log('Inicio', startDate)
              // console.log('Fin', endDate)
              // nameDate = filas[key].name
              // console.log('today >= startDate && today <= endDate', today >= startDate, today <= endDate, today >= startDate, today <= filas[key].date_end, today, endDate, filas[key].name)
              // if (today >= startDate && today <= endDate) {
              //   nameDate = filas[key].name
              // }
            }
            // console.log('nameDate', nameDate)
            return nameDate
          }
        }
      } catch (error) {
        console.log('calculateDates', error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async updateEnterpriseValue (...args) {
      console.log('updateEnterpriseValue', args)
      const reformattedArray = this.enterprises.find(el => {
        return el.name.toUpperCase() === args[0].toUpperCase()
      })
      const dates = await this.calculateDates(reformattedArray)
      console.log('datesXDXD', dates, reformattedArray)
      args[2].id_provider = reformattedArray.id_provider
      if (dates === undefined) {
        console.log('indefinidos')
        this.$toastedPush({
          message: 'No existe Fecha configuradas para este mes del proveedor ' + args[0].toUpperCase(),
          type: 'error'
        })
      } else {
        args[2].delivery_date = dates.toUpperCase()
      }
    },
    updateNumber (...args) {
      args[2].numero = args[0]
      this.savePedidos()
    },
    updateModel (...args) {
      args[2].modelo = args[0]
      this.savePedidos()
    },
    updateClientValue (...args) {
      console.log('* * * ** updateClientValue', args)
      const reformattedArray = this.clients.find(el => {
        return parseInt(el.key_client) === parseInt(args[0])
      })
      args[2].nameClient = reformattedArray.name + ' ' + reformattedArray.lastname1 + ' ' + reformattedArray.lastname2
      args[2].client = reformattedArray.key_client
    },
    async duplicar () {
      try {
        const selected = this.$refs.grid.getSelectedRecords()
        console.log('duplicar', selected)
        if (selected.length > 0) {
          if (this.duplicateE > 0) {
            const request = {
              order_id: selected[0].order,
              amount: this.duplicateE
            }
            console.log('params', request)
            const response = await axiosAdelaService.post('/duplicateOrderRow', request)
            console.log('duplicateOrderRow', response)
            if (response.status === 200) {
              await this.getOrdersSaved()
              this.$toastedPush({
                message: 'Orden duplicada...',
                type: 'success'
              })
            }
          } else {
            this.showError('Ingrese la cantidad de elementos que desea duplicar..')
          }
        } else {
          this.showError('Seleccione un elemento a duplicar..')
        }
        this.$modal.hide('duplicate')
        this.duplicateE = 1
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los clientes, por favor intentelo mas tarde')
      }
    },
    async agregarFaltante () {
      try {
        const selected = this.$refs.grid.getSelectedRecords()
        console.log('faltante', selected)
        const request = {
          data: selected
        }
        console.log('params', request)
        const response = await axiosAdelaService.post('/updateOrderFaltante', request)
        console.log('faltante', response)
        if (response.status === 200) {
          await this.getOrdersSaved()
          this.$toastedPush({
            message: 'Ordenes marcadas como faltantes correctamente...',
            type: 'success'
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los clientes, por favor intentelo mas tarde')
      }
    }
  },
  async mounted () {
    await this.getProviders()
    await this.getClients()
    const open = await this.getOrdersSaved()
    if (!open) {
      this.addRows(5)
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    today () {
      return moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    clientNumber (value) {
      this.searchClient(value)
    }
  }
}
</script>

<style>
.inputNumberClient {
  border-radius: 10px;
  border-color: red;
  text-align: center;
}
.btnAddOrder {
  border: none;
  font-size: 18px;
  border-radius: 10px;
  color: white;
}
.btnAddRow {
  font-size: 30px;
  background: #22da65;
  width: 100px;
}
.btnRegister {
  background: #227bda;
  padding: 5px;
}
.btnDelete {
  background: red;
  padding: 5px;
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
